const state = {
  states: [
    'Johor',
    'Kedah',
    'Kelantan',
    'Melaka',
    'Negeri Sembilan',
    'Pahang',
    'Perak',
    'Perlis',
    'Pulau Pinang',
    'Sabah',
    'Sarawak',
    'Selangor',
    'Terengganu',
    'WP Kuala Lumpur',
    'WP Labuan',
    'WP Putrajaya'
  ]
}

const getters = {
  getStates: (state) => state.states,
  getStatesFormatted: (state) => state.states.map(option => ({text: option, value: option}))
}

const mutations = {}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions
}